import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; 
import { FgFormModule, FgListModule, SharedModule } from 'fg-library';
import { FgDynamicPageBuilder } from './fg-dynamic-page-builder.component';
import { FgSchemaImportBuilderComponent } from './fg-schema-import-dialog-box/fg-schema-import-dialog-box.component';
import { ChartVariantDialogComponent } from './chart-variant-dialog.component';
import { MatBadgeModule } from '@angular/material/badge';
import { LayoutService } from '../../shared/components/main-nav/layoutservice';


@NgModule({ declarations: [
        FgDynamicPageBuilder,
        FgSchemaImportBuilderComponent,
        ChartVariantDialogComponent,
    ], imports: [CommonModule,
        FgListModule,
        FormsModule,
        FgFormModule,
        SharedModule,
        MatBadgeModule], providers: [LayoutService, provideHttpClient(withInterceptorsFromDi())] })

export class FgDynamicPageBuilderModule {


}
